/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        data: {
            init: false,
            lang: 'eng',
            menu: [
                {
                    name: {
                        eng: 'Work',
                        nl: 'Werk'
                    },
                    slug: 'work',
                    alt: ''
                },
                {
                    name: {
                        eng: 'About',
                        nl: 'Over ons'
                    },
                    slug: 'about',
                    alt: ''
                },
                {
                    name: {
                        eng: 'Team',
                        nl: 'Team'
                    },
                    slug: 'team',
                    alt: ''
                },
                {
                    badge: '4',
                    name: {
                        eng: 'Jobs',
                        nl: 'Vacatures'
                    },
                    slug: 'jobs',
                    alt: ''
                },
                // {
                //     name: {
                //         eng: 'News',
                //         nl: 'Nieuws'
                //     },
                //     slug: 'news',
                //     alt: ''
                // },
                {
                    name: {
                        eng: 'Contact',
                        nl: 'Contact'
                    },
                    slug: 'contact',
                    alt: ''
                }
            ],
            contact: {
                call: {
                    text: {
                        eng: 'Call me back',
                        nl: 'Terugbellen',
                    },
                    days: {
                        text: {
                            eng: 'Select a day',
                            nl: 'Selecteer een dag'
                        },
                        options: [
                            {
                                eng: 'Monday',
                                nl: 'Maandag'
                            },
                            {
                                eng: 'Tuesday',
                                nl: 'Dinsdag'
                            },
                            {
                                eng: 'Wednesday',
                                nl: 'Woensdag'
                            },
                            {
                                eng: 'Thursday',
                                nl: 'Donderdag'
                            },
                            {
                                eng: 'Friday',
                                nl: 'Vrijdag'
                            }
                        ]
                    },
                    times: {
                        text: {
                            eng: 'Select a time',
                            nl: 'Selecteer een tijdstip'
                        },
                        options: [
                            {
                                eng: 'Morning',
                                nl: 'Ochtend'
                            },
                            {
                                eng: 'Afternoon',
                                nl: 'Middag'
                            },
                            {
                                eng: 'End of the day',
                                nl: 'Eind van de dag'
                            }
                        ]
                    }
                },
                mail: {
                    general: {
                        name: {
                            eng: 'General info',
                            nl: 'Algemene informatie'
                        },
                        email: 'info@vruchtvlees.com'
                    },
                    business: {
                        name: {
                            eng: 'New business',
                            nl: 'Aanvragen'
                        },
                        email: 'roman@vruchtvlees.com'
                    },
                    press: {
                        name: {
                            eng: 'Press & communication',
                            nl: 'Pers & communicatie'
                        },
                        email: 'lotte@vruchtvlees.com'
                    },
                    jobs: {
                        name: {
                            eng: 'Jobs',
                            nl: 'Vacatures'
                        },
                        email: 'rindor@vruchtvlees.com'
                    }
                },
                address: {
                    street: 'Joseph Ledelstraat 98',
                    postcode: '2518KM',
                    city: 'Den Haag',
                    country: 'The Netherlands'
                },
                connect: {
                    email: 'info@vruchtvlees.com',
                    phone: '070 - 785 1734'
                },
                socials: [
                    {
                        name: 'Facebook',
                        link: 'https://www.facebook.com/vruchtvlees'
                    },
                    {
                        name: 'Instagram',
                        link: 'https://instagram.com/vruchtvlees'
                    },
                    {
                        name: 'LinkedIn',
                        link: 'https://www.linkedin.com/company/vruchtvlees'
                    },
                ]
            },
            logos: [
                {
                    name: 'Dutch Design Week',
                    image: '/assets/logos/dutch-design-week.png'
                },
                {
                    name: 'Ace n Tate',
                    image: '/assets/logos/ace-n-tate.png'
                },
                {
                    name: 'Gispen',
                    image: '/assets/logos/gispen.png'
                },
                {
                    name: 'Concert Gebouw',
                    image: '/assets/logos/concert-gebouw.png'
                },
                {
                    name: 'T-Mobile',
                    image: '/assets/logos/t-mobile.png'
                },
                {
                    name: 'Onefit',
                    image: '/assets/logos/onefit.png'
                },
                {
                    name: 'VPRO',
                    image: '/assets/logos/vpro.png'
                },
                {
                    name: 'Theater Rotterdam',
                    image: '/assets/logos/theater-rotterdam.png'
                },
                {
                    name: 'De Vegetarische Slager',
                    image: '/assets/logos/vegetarische-slager.png'
                },
                {
                    name: 'Koninklijke Bibliotheek',
                    image: '/assets/logos/bibliotheek.png'
                },
                {
                    name: 'Miro',
                    image: '/assets/logos/miro.png'
                },
                {
                    name: 'Ancienne Belgique',
                    image: '/assets/logos/ancienne-belgique.png'
                }
            ],
            names: {
                next: {
                    eng: 'Next up',
                    nl: 'Volgende project'
                },
                newsletter: {
                    title: {
                        eng: 'Get our newsletter',
                        nl: 'Ontvang onze nieuwsbrief'
                    },
                    subtitle: {
                        eng: 'Stay in the loop',
                        nl: 'Blijf op de hoogte'
                    },
                    placeholder: {
                        eng: 'Your e-mail address',
                        nl: 'Jouw e-mail adres'
                    },
                    error: {
                        eng: 'Oops, no valid email!',
                        nl: 'Oeps, geen email adres!'
                    },
                },
                logos: {
                    title: {
                        eng: 'We work for ambitious brands',
                        nl: 'Wij werken voor ambitieuze merken'
                    },
                    text: {
                        eng: 'Whether it’s a brand, new product or a new target group, we provide solutions for every need.',
                        nl: 'Ongeacht het een nieuw merk, product of een doelgroep betreft, wij maken oplossingen voor elk probleem:'
                    }
                },
                mail: {
                    subtitle: {
                        eng: 'How can we help?',
                        nl: 'Hoe kunnen we helpen?'
                    },
                    title: {
                        eng: 'Let’s talk',
                        nl: 'Wie kan je helpen?'
                    }
                },
                call: {
                    subtitle: {
                        eng: 'Feeling lazy?',
                        nl: 'Doe geen moeite'
                    },
                    title: {
                        eng: 'We’ll call you!',
                        nl: 'Wij bellen je terug!'
                    }
                },
                jobs: {
                    subtitle: {
                        eng: 'Are you the one?',
                        nl: 'Ben jij onze nieuwe collega?'
                    },
                    title: {
                        eng: 'We’re looking for:',
                        nl: 'We zijn op zoek naar:'
                    }
                }
            }
        }
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;